import { render, staticRenderFns } from "./DxBinsContentGridMove.vue?vue&type=template&id=d5e84172&"
import script from "./DxBinsContentGridMove.vue?vue&type=script&lang=js&"
export * from "./DxBinsContentGridMove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports